var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      staticClass: "content-row cursor-pointer animated flipInX",
      class: { selected: _vm.isSelected },
      attrs: { id: "file-" + _vm.element.id },
      on: { dblclick: _vm.dblClickAction }
    },
    [
      _c("td", { staticClass: "text-center" }, [
        _vm.element.type === "file"
          ? _c("div", [
              _c(
                "span",
                { staticClass: "pr-1" },
                [
                  _c("font-awesome-icon", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.publicationStateIcon(_vm.element).tooltip,
                        expression: "publicationStateIcon(element).tooltip"
                      }
                    ],
                    class: _vm.publicationStateIcon(_vm.element).classes,
                    attrs: {
                      icon: ["fas", _vm.publicationStateIcon(_vm.element).icon],
                      size: "xs"
                    }
                  })
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "pr-1" },
                [
                  _c("font-awesome-icon", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.validityStateIcon(_vm.element).tooltip,
                        expression: "validityStateIcon(element).tooltip"
                      }
                    ],
                    class: _vm.validityStateIcon(_vm.element).classes,
                    attrs: {
                      icon: ["fas", _vm.validityStateIcon(_vm.element).icon],
                      size: "xs"
                    }
                  })
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "pr-1" },
                [
                  _c("font-awesome-icon", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.approvalStateIcon(_vm.element).tooltip,
                        expression: "approvalStateIcon(element).tooltip"
                      }
                    ],
                    class: _vm.approvalStateIcon(_vm.element).classes,
                    attrs: {
                      icon: ["fas", _vm.approvalStateIcon(_vm.element).icon],
                      size: "xs"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _c("td", { staticClass: "noselect", on: { click: _vm.clicksCheck } }, [
        _c(
          "span",
          { staticClass: "pt-3" },
          [
            _vm.element.type === "folder"
              ? _c("font-awesome-icon", {
                  staticStyle: { color: "orange" },
                  attrs: { icon: ["fas", "folder"] }
                })
              : _vm._e(),
            _vm.element.type === "file"
              ? _c("font-awesome-icon", {
                  class: _vm.fileTypeIcon(_vm.element),
                  attrs: { icon: ["fas", _vm.fileTypeIcon(_vm.element)] }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" " + _vm._s(_vm.element.name) + " "),
        _vm.element.documentId
          ? _c(
              "span",
              {
                staticClass: "material-icons",
                staticStyle: { "font-size": "18px", color: "dodgerblue" }
              },
              [_vm._v(" link ")]
            )
          : _vm._e(),
        _vm.element.type === "folder"
          ? _c(
              "div",
              [
                _vm.element.numberOfFolders
                  ? _c(
                      "b-badge",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Cantidad de carpetas",
                            expression: "'Cantidad de carpetas'"
                          }
                        ],
                        staticClass: "mr-2",
                        attrs: { variant: "light-success" }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticStyle: { color: "#386f17" },
                          attrs: { icon: ["fas", "folder"] }
                        }),
                        _vm._v(" " + _vm._s(_vm.element.numberOfFolders) + " ")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.element.numberOfFiles
                  ? _c(
                      "b-badge",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Cantidad de archivos",
                            expression: "'Cantidad de archivos'"
                          }
                        ],
                        staticClass: "mr-2",
                        attrs: { variant: "light-info" }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticStyle: { color: "#006c79" },
                          attrs: { icon: ["fas", "file-archive"] }
                        }),
                        _vm._v(" " + _vm._s(_vm.element.numberOfFiles) + " ")
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _c("td", { staticClass: "text-center text-gray" }, [
        _vm._v(" " + _vm._s(_vm.size) + " ")
      ]),
      _c("td", { staticClass: "text-gray" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$moment(_vm.element.creationDate).format("DD-MM-YYYY H:mm")
            ) +
            " "
        )
      ]),
      _c("td", { staticClass: "text-gray" }, [
        _vm._v(" " + _vm._s(_vm.element.owner) + " ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }